export class saldo_documento {
    codigo : number;
    rut_emisor : number;
    folio:number;
    tipo_dte_codigo:number;
    sucursal_codigo:number;
    cliente_proveedor_rut:number;
    fecha_emision:Date;
    vendedor_codigo: number;
    vendedor_nombre:String;
    recorrido_codigo:number;
    recorrido_estado:boolean;
    protesto_cheque_codigo:number;
    reversa_pago_codigo: number;
    tipo_pago: String;
    ref_doc: String;
    pagado:boolean;
    monto:number;
    saldo:number;
    pago:number;
    deuda:number;
    seleccion:boolean;
}